import React, { useEffect } from 'react';
import * as Privy from 'privy-sdk';
import { useDispatch, useSelector } from 'react-redux';
import ROUTER_PATH from 'app/routes/routerPath';
import { RootState } from "app/redux/store";
import environment from 'environments/environment';
import './PrivyComponent.scss';
import { useNavigate } from 'react-router-dom';
import { setNavHeaderVisibleAction } from 'app/redux/actions/NavHeaderAction';
import { resetFundingStateAction } from 'app/redux/actions/FundingAction';

const PrivyComponent = function init(): React.ReactElement {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const fundingState = useSelector((state: RootState) => state.fundingReducer);
	const { docToken, signCoordinatePage, digiSignId } = fundingState;

	function initPrivy(): void {
		Privy.openDoc(docToken, {
			dev: !environment.prod,
			container: '.privy-document',
			privyId: digiSignId,
			signature: {
				page: signCoordinatePage,
				x: 130,
				y: 468,
				fixed: false
			},
		})
		.on('after-action', () => {
			navigate(ROUTER_PATH.afterFundingPage);
		});
	}

	useEffect(() => {
		dispatch(setNavHeaderVisibleAction(false));
		initPrivy();
	}, []);

	useEffect(() => () => {
		dispatch(setNavHeaderVisibleAction(true));
	}, []);

	useEffect(() => {
		window.addEventListener('popstate', () => {
			dispatch(resetFundingStateAction(true));
			navigate(ROUTER_PATH.index);
		});
	}, []);

    return (
        <div className="h-10">
			<div className="privy-document" />
        </div>
    );
};

export default PrivyComponent;
